import {
  FEATURE_LITIGATION,
  formatEur,
  MAX_SEATS_PER_INSTANCE,
  MONTHLY_FEE_PREMIUM,
  MONTHLY_FEE_PROFESSIONAL,
  SEATS_PREMIUM,
  SEATS_PROFESSIONAL,
  SETUP_FEE,
  TARIF_ENTERPRISE,
  TARIF_PREMIUM,
  TARIF_PROFESSIONAL,
} from '../../../constants';
import type { T05PricingPlan } from './T05PricingSection';

export const LITIGATION_ADDON_FEE = 99;
export const LITIGATION_ADDON_COUNT = 10;

export function buildOrbisPricingPlans(options?: { onDemo?: () => void }): T05PricingPlan[] {
  const onCta = options?.onDemo;
  return [
    {
      eyebrow: `${SEATS_PROFESSIONAL} Sitze inkl.`,
      name: TARIF_PROFESSIONAL,
      price: formatEur(MONTHLY_FEE_PROFESSIONAL),
      priceNote: `pro Monat · Setup ${formatEur(SETUP_FEE)}`,
      description:
        'Für Einzelanwälte und Kanzleien mit voller Orbis-Basis: Diktat, ARKO, BRAIN/LEXCORE, Portal, OnlyOffice, Nextcloud, Matrix.',
      bg: 'var(--t05-pricing-bg-base)',
      ctaLabel: 'Demo anfragen',
      onCta,
      features: [
        { text: `${SEATS_PROFESSIONAL} Sitze inklusive`, included: true },
        { text: `Max. ${MAX_SEATS_PER_INSTANCE} Sitze pro Instanz`, included: true },
        { text: 'Kanzlei-Portal & alle Basis-Bausteine', included: true },
        { text: `Ohne ${FEATURE_LITIGATION}`, included: false },
      ],
    },
    {
      eyebrow: `Empfohlen · ${SEATS_PREMIUM} Sitze`,
      name: TARIF_PREMIUM,
      price: formatEur(MONTHLY_FEE_PREMIUM),
      priceNote: `pro Monat · Setup ${formatEur(SETUP_FEE)}¹`,
      description: `Alles aus Professional plus ${FEATURE_LITIGATION}: Gegnerischen Schriftsatz hochladen, KI-Analyse, Strategie-PDF. Doppelte Pseudonymisierung, Opt-In je Analyse.`,
      bg: 'var(--t05-pricing-bg-featured)',
      featured: true,
      badge: 'Empfohlen',
      ctaLabel: 'Demo anfragen',
      onCta,
      features: [
        { text: `${SEATS_PREMIUM} Sitze inklusive`, included: true },
        { text: 'Voller Portal-Umfang', included: true },
        { text: `${FEATURE_LITIGATION} inklusive`, included: true },
        { text: 'Upgrade ohne erneutes Setup¹', included: true },
      ],
    },
    {
      eyebrow: `>${MAX_SEATS_PER_INSTANCE} Sitze`,
      name: TARIF_ENTERPRISE,
      price: 'Individuell',
      priceNote: 'Setup & Monat nach Angebot',
      description:
        'Ab 21 Sitzen, zweite Instanz, upsized Dedicated Server oder individuelles SLA. Gesondertes Angebot.',
      bg: 'var(--t05-pricing-bg-base)',
      wide: true,
      ctaLabel: 'Angebot anfragen',
      onCta,
      features: [
        { text: 'Individuelle Sitzzahl', included: true },
        { text: 'Individuelles SLA möglich', included: true },
        { text: 'Mehrere Instanzen', included: true },
        { text: `${FEATURE_LITIGATION} nach Bedarf`, included: true },
      ],
    },
  ];
}

export function buildLitigationPricingPlans(options?: { onPricing?: () => void }): T05PricingPlan[] {
  const onCta = options?.onPricing;
  return [
    {
      eyebrow: `Empfohlen · ${SEATS_PREMIUM} Sitze`,
      name: TARIF_PREMIUM,
      price: formatEur(MONTHLY_FEE_PREMIUM),
      priceNote: `pro Monat · ${SEATS_PREMIUM} Sitze inklusive`,
      description: `Voller Orbis-Umfang plus ${FEATURE_LITIGATION} mit Inklusiv-Kontingent laut Vertrag.`,
      bg: 'var(--t05-pricing-bg-featured)',
      featured: true,
      badge: 'Empfohlen',
      ctaLabel: 'Premium anfragen',
      onCta,
      features: [
        { text: `${FEATURE_LITIGATION} inklusive`, included: true },
        { text: 'Doppelte Pseudonymisierung', included: true },
        { text: 'Opt-In je Analyse', included: true },
        { text: 'Voller Portal-Umfang', included: true },
      ],
    },
    {
      eyebrow: 'Nachkauf',
      name: 'Analysen-Paket',
      price: formatEur(LITIGATION_ADDON_FEE),
      priceNote: `pro Paket · ${LITIGATION_ADDON_COUNT} Analysen`,
      description:
        'Zusätzliches Guthaben für Premium-Kunden — Rollforward bis 24 Monate ab Kaufdatum. Inklusiv-Analysen verfallen monatlich.',
      bg: 'var(--t05-pricing-bg-base)',
      badge: 'Add-on',
      ctaLabel: 'Nachkauf anfragen',
      onCta,
      features: [
        { text: `${LITIGATION_ADDON_COUNT} Litigation-Analysen`, included: true },
        { text: '24 Monate Gültigkeit ab Kauf', included: true },
        { text: `Nur für ${TARIF_PREMIUM}`, included: true },
      ],
    },
  ];
}
